import React from "react";
import { avatarKleur } from "./afsprakenUtils";

export const OpvolgerAvatar = ({ name, size = "h-6 w-6 text-[11px]" }) => {
  if (!name) {
    return <span aria-hidden className={`${size} rounded-full border border-dashed border-amber-500 text-amber-600 font-bold flex items-center justify-center shrink-0`}>?</span>;
  }
  return <span aria-hidden className={`${size} rounded-full ${avatarKleur(name)} text-white font-bold uppercase flex items-center justify-center shrink-0`}>{name[0]}</span>;
};

export const OpvolgerLabel = ({ a, testid, compact = false }) => {
  const name = a.opvolgerEffectief;
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 text-xs min-w-0">
      <OpvolgerAvatar name={name} />
      {!name ? (
        <span className="text-amber-700 font-semibold whitespace-nowrap">{compact ? "Geen" : "Geen opvolger"}</span>
      ) : (
        <span className={`truncate ${a.opvolgerActief ? "text-zinc-700" : "text-amber-700 font-semibold"}`}>
          <span className="capitalize">{name}</span>{!a.opvolgerActief && " (uit dienst)"}
        </span>
      )}
    </span>
  );
};
